import React, { useMemo, useState, useEffect } from "react";
import { Table } from "../../Components/Table/Table";
import DateFilter from "../../Components/Date/DateFilter";
import { employee_report } from "../../api/employeereport";

const TimeSheet = () => {
  const [pageno, setPageno] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const params = { search, status: statusFilter, fromDate, toDate };

      const res = await employee_report(params);

      const formatted = res.data.map((item, index) => ({
        sno: index + 1,
        date: item.date,
        checkin: item.checkInTime
          ? new Date(item.checkInTime).toLocaleTimeString()
          : "-",
        checkout: item.checkOutTime
          ? new Date(item.checkOutTime).toLocaleTimeString()
          : "-",
        status: item.status,
        productionhour:
          item.checkInTime && item.checkOutTime
            ? (
                (new Date(item.checkOutTime) -
                  new Date(item.checkInTime)) /
                1000 /
                60 /
                60
              ).toFixed(2)
            : 0,
        createdAt: new Date(item.createdAt).toLocaleDateString(),
      }));

      setData(formatted);
    } catch (err) {
      console.error("Error fetching attendance:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search, statusFilter, fromDate, toDate]);

  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Date", accessor: "date" },
      { Header: "Check-In", accessor: "checkin" },
      { Header: "Check-Out", accessor: "checkout" },
      { Header: "Status", accessor: "status" },
      { Header: "Production Hours", accessor: "productionhour" },
      { Header: "Created At", accessor: "createdAt" },
    ],
    []
  );

  return (
    <div className="timesheet-container">
      <h2 className="timesheet-title">My Attendance</h2>

      {/* Filters */}
      <div className="filter-bar">
        <input
          type="text"
          className="filter-input"
          placeholder="Search by status or date..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Present">Present</option>
          <option value="Absent">Absent</option>
          <option value="Late">Late</option>
          <option value="Half Day">Half Day</option>
        </select>

        <DateFilter
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </div>

      {/* Table */}
      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show
      />
    </div>
  );
};

export default TimeSheet;